import Entity from "./Entity";

export default class User extends Entity {
    constructor(data) {
        super(data);
    }

    getId() {
        return this.get("id");
    }

    getEmail() {
        return this.get("email");
    }

    isSuperAdmin() {
        const superAdmin = this.get("superadmin");
        if (superAdmin) {
            return superAdmin
        } else {
            return false;
        }
    }
}